import {
    ApplicationStartupOptions,
    IApplicationModuleSession,
    IApplicationSession,
    IPlatformViewport, IPlatformViewportCreateAppOptions, IPlatformViewportEvent,
    IUIOperationOptions, PlatformViewportEventAction
} from "./PA.UIM.Core.IF.Platform";
import * as _ from "lodash"
import {IApplication, IApplicationModule} from "./PA.UIM.Core.IF.Framework";
import {IIdentityProvider} from "../PA.Core/PA.Core.IF.Basic";
import {BehaviorSubject} from "rxjs";
import {IBusinessObject} from "../PA.Core/PA.Core.IF.BO";
import {PlatformSession} from "./PlatformSession";
import {IdentityProvider} from "../PA.Core/Basic/Identity";
import {ApplicationModuleSession} from "./ApplicationModuleSession";
import {ASync} from "../PA.Core/Basic/ASync";
import {UIClipboardService} from "../PA.UIFramework.Services/UIFrameworkService";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

export class ApplicationSession
    implements IApplicationSession {
    private _SessionId: number
    private _Identity: IIdentityProvider
    private _PlatformViewport: IPlatformViewport
    private _Application: IApplication
    private _ApplicationModuleSessions: IApplicationModuleSession[];
    private _renderOptions: { [id: string]: any }

    private _OnApplicationModuleSessionsChange: BehaviorSubject<IPlatformViewportEvent>;
    private _OnApplicationSessionPropertyChange: BehaviorSubject<any>

    private _dtcMRU: { [id: string]: string }[]


    constructor(platformViewport: IPlatformViewport, anApplication: IApplication, options?: IPlatformViewportCreateAppOptions) {
        const opts = options || {}

        this._SessionId = PlatformSession.getNextSessionId()
        this._Identity = new IdentityProvider({id: this._SessionId, id_ui: this._SessionId, name: anApplication.name})
        this._PlatformViewport = platformViewport
        this._Application = anApplication
        this._ApplicationModuleSessions = []
        this._renderOptions = undefined

        this._OnApplicationModuleSessionsChange = new BehaviorSubject<IPlatformViewportEvent>(undefined)
        this._OnApplicationSessionPropertyChange = new BehaviorSubject<any>(undefined)

        this._dtcMRU = []
    }

    get SessionId(): number {
        return this._SessionId
    }

    get Identity(): IIdentityProvider {
        return this._Identity
    }

    get PlatformViewport(): IPlatformViewport {
        return this._PlatformViewport
    }

    get Application(): IApplication {
        return this._Application
    }

    get ApplicationModuleSessions(): IApplicationModuleSession[] {
        return this._ApplicationModuleSessions
    }

    get CurrentApplicationModuleSession(): IApplicationModuleSession {
        return this.PlatformViewport.Renderer.getInFocusApplicationModuleSession(this)
    }

    get OnApplicationModuleSessionsChange(): BehaviorSubject<IPlatformViewportEvent> {
        return this._OnApplicationModuleSessionsChange
    }

    get OnApplicationSessionPropertyChange(): BehaviorSubject<any> {
        return this._OnApplicationSessionPropertyChange
    }

    RunStartup(options?: ApplicationStartupOptions): Promise<void> {
        const self = this
        let opts = options || {}

        return new Promise<void>((resolve, error) => {

            if (!this._dtcMRU.length) {
                let cs = new UIClipboardService()
                let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
                let usrId = usrContext.User.cif.WB_AUTHUSR_ID
                cs.FindClipboardEntry(
                    {"usage": 'Dimension', "subUsage": 'Report', "wbUserId": usrId}
                )
                    .then((items) => {
                        _.forEach(items, item => {

                            if (!_.isEmpty(item.Clip)) {
                                this._dtcMRU.push(item.Clip)
                            }
                        })

                        let cntAutoModule = _.filter(self.Application.applicationModules, aModule => ((aModule.startupPolicy === 'AutoStart') || (aModule.startupPolicy === 'AutoStartSearch'))).length
                        let cntProcessedModule = 0
                        let searchSessions: IApplicationModuleSession[] = []
                        let autoLoadSession = undefined
                        let createdSessions: number[] = []
                        _.forEach(_.orderBy(self.Application.applicationModules, ['sort'], ['desc']), (aModule) => {
                            if (_.isEmpty(aModule)) {
                                return
                            }
                            if ((aModule.startupPolicy === 'AutoStart') || (aModule.startupPolicy === 'AutoStartSearch') || ('loadWithParam' in opts && opts.loadWithParam)) {
                                cntProcessedModule++
                                let aModuleSession: IApplicationModuleSession = undefined
                                if (!_.filter(self.ApplicationModuleSessions, (aModuleSession: IApplicationModuleSession) => aModuleSession.ApplicationModule.wb_id == aModule.wb_id).length) {
                                    if(aModule.executable.searchClass != undefined &&  !('loadWithParam' in opts && opts.loadWithParam)) {
                                        aModuleSession = self.CreateModuleSession(aModule.wb_id, {bIsSearchSession: true})
                                        searchSessions.push(aModuleSession)
                                    }
                                    else
                                        aModuleSession = self.CreateModuleSession(aModule.wb_id, {})

                                    createdSessions.push(aModule.wb_id)
                                }
                                else {
                                    aModuleSession = _.first(_.filter(self.ApplicationModuleSessions, (aModuleSession: IApplicationModuleSession) => aModuleSession.ApplicationModule.wb_id == aModule.wb_id))
                                    autoLoadSession = aModuleSession
                                }
                                aModuleSession.RunStartup()
                                if (cntAutoModule == cntProcessedModule)
                                    self.PlatformViewport.Renderer.setFocus(aModuleSession)
                                if (aModule.executableParams?.autoLoad || ('loadWithParam' in opts && opts.loadWithParam))
                                    autoLoadSession = aModuleSession
                            }

                            //create a search session for every application module that has placement as toolbar
                            if (
                                aModule.placementPolicy == "Toolbar" &&
                                self.Application.id_ui != 'App_LaunchPad' &&
                                aModule.executable.searchClass != undefined &&
                                aModule.executable.tbSearchShowInd &&
                                createdSessions.indexOf(aModule.wb_id) == -1
                            ) {
                                let aModuleSearchSession: IApplicationModuleSession = undefined
                                aModuleSearchSession = self.CreateModuleSession(aModule.wb_id, {bIsSearchSession: true})
                                searchSessions.push(aModuleSearchSession)
                            }
                        })

                        let searchSessionCount = searchSessions.length
                        if (searchSessionCount > 0 && !('loadWithParam' in opts && opts.loadWithParam)) {
                            let lastSession = _.last(searchSessions)
                            self.PlatformViewport.Renderer.setFocus(lastSession)
                        }

                        if (!_.isEmpty(autoLoadSession))
                            self.PlatformViewport.Renderer.setFocus(autoLoadSession)

                        resolve()
                    })
                    .catch((err) => {
                        console.log("Unable to get Recent Items: ", err)
                        error(err)
                    })
            }
        })
    }


    Create(anExecutableId: string, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule?.executable?.id_ui == anExecutableId) {
                return self.CreateModuleSession(anAppModule.wb_id, options)
            }
        }

        return undefined
    }

    CreateModuleSession(anWbAppModuleId: number, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        //anything that shows up on toolbar create a search app session

        let foundAppModule: IApplicationModule = undefined
        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule.wb_id == anWbAppModuleId) {
                foundAppModule = anAppModule
                break
            }
        }

        if (_.isEmpty(foundAppModule)) {
            //-- Message
            return
        }

        //--
        let newSession = new ApplicationModuleSession(self.PlatformViewport, self, foundAppModule, options)
        self._ApplicationModuleSessions.push(newSession)
        self.OnApplicationModuleSessionsChange.next({
            action: PlatformViewportEventAction.ApplicationModulesSessionAdded,
            appSession: self,
            appModuleSession: newSession
        })
        self.PlatformViewport.Renderer.renderSession(newSession)


        return newSession
    }

    Open(anExecutableId: string, BOid: string | number, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule?.executable?.id_ui == anExecutableId) {
                return self.OpenModuleSession(anAppModule.wb_id, BOid, options)
            }
        }

        return undefined
    }

    OpenModuleSession(anWbAppModuleId: number, BOid: string | number, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        let foundAppModule: IApplicationModule = undefined
        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule.wb_id == anWbAppModuleId) {
                foundAppModule = anAppModule
                break
            }
        }

        if (_.isEmpty(foundAppModule)) {
            //-- Message
            return
        }

        let returnValue = self.FindSessionByObjectId(foundAppModule.executable.id_ui, BOid)
        if (returnValue) {
            self.PlatformViewport.Renderer.setFocus(returnValue)
            return returnValue
        }

        returnValue = self.CreateModuleSession(anWbAppModuleId, options)
        returnValue.LoadId(BOid, options)
        return returnValue
    }


    OpenBO(anExecutableId: string, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule?.executable?.id_ui == anExecutableId) {
                return self.OpenBOModuleSession(anAppModule.wb_id, aBO, options)
            }
        }

        return undefined
    }

    OpenBOModuleSession(anWbAppModuleId: number, aBO: IBusinessObject, options?: IUIOperationOptions): IApplicationModuleSession {
        const self = this

        let foundAppModule: IApplicationModule = undefined
        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule.wb_id == anWbAppModuleId) {
                foundAppModule = anAppModule
                break
            }
        }

        if (_.isEmpty(foundAppModule)) {
            //-- Message
            return
        }

        let returnValue = self.FindSessionByBO(foundAppModule.executable.id_ui, aBO)
        if (returnValue) {
            self.PlatformViewport.Renderer.setFocus(returnValue)
            return returnValue
        }

        let skipOptions = options || {}
        skipOptions.BusinessObjectCreateNewOnSessionCreateSkip = true
        returnValue = self.CreateModuleSession(anWbAppModuleId, options)
        returnValue.SetBO(aBO)
        return returnValue
    }


    Close(anExecutableId: string, BOid: string | number, options?: IUIOperationOptions): Promise<boolean> {
        const self = this
        async function closeModules() {
            let bCanClose = true
            for (let anAppModule of self.Application.applicationModules) {
                if (anAppModule?.executable?.id_ui == anExecutableId) {
                    bCanClose = await self.CloseModuleSession(anAppModule.wb_id, BOid, options)
                    if (!bCanClose)
                        break
                }
            }
            return bCanClose
        }

        return ASync.resolve(closeModules())


    }

    CloseModuleSession(anWbAppModuleId: number, BOid: string | number, options?: IUIOperationOptions): Promise<boolean> {
        const self = this

        let foundAppModule: IApplicationModule = undefined
        for (let anAppModule of self.Application.applicationModules) {
            if (anAppModule.wb_id == anWbAppModuleId) {
                foundAppModule = anAppModule
                break
            }
        }

        if (_.isEmpty(foundAppModule)) {
            //-- Message
            return
        }

        let returnValue = self.FindSessionByObjectId(foundAppModule.executable.id_ui, BOid)
        if (returnValue) {
            return returnValue.Close()
        }

        return ASync.resolve(true)
    }


    getAppModules(anExecutableId: string): IApplicationModule[] {
        const self = this
        let returnValue: IApplicationModule[] = []
        _.forEach(self.Application.applicationModules, (aModule) => {
            if (aModule.executable.id_ui == anExecutableId) {
                returnValue.push(aModule)
            }
        })
        return returnValue
    }

    hasExecutable(anExecutableId: string): boolean {
        const self = this
        let returnValue = false
        _.forEach(self.Application.applicationModules, (aModule) => {
            if (aModule.executable.id_ui == anExecutableId) {
                returnValue = true
                return false
            }
        })
        return returnValue
    }

    PruneSession(anAppModuleSession: IApplicationModuleSession): void {
        const self = this

        _.remove(self.ApplicationModuleSessions, (a) => a.SessionId == anAppModuleSession?.SessionId)
        self.OnApplicationModuleSessionsChange.next({
            action: PlatformViewportEventAction.ApplicationModulesSessionRemoved,
            appSession: self,
            appModuleSession: anAppModuleSession
        })
    }

    private FindSessionByObjectId(anExecutableId: string, id: string | number): IApplicationModuleSession {
        const self = this

        let appModuleSession: IApplicationModuleSession = undefined

        _.forEach(self.ApplicationModuleSessions, (ams) => {
            if (ams?.ApplicationModule?.executable?.id_ui == anExecutableId) {
                if (ams.isObject(id) || ams.SessionId===id) {
                    appModuleSession = ams
                    return false
                }
            }
        })
        return appModuleSession
    }

    private FindSessionByBO(anExecutableId: string, aBO: IBusinessObject): IApplicationModuleSession {
        const self = this

        let appModuleSession: IApplicationModuleSession = undefined
        _.forEach(self.ApplicationModuleSessions, (ams) => {
            if (ams?.ApplicationModule?.executable?.id_ui == anExecutableId) {
                if (ams.isBusinessObject(aBO)) {
                    appModuleSession = ams
                    return false
                }
            }
        })

        return appModuleSession
    }

    RenderOptions(): { [id: string]: any } {
        return this._renderOptions
    }

    setRenderOptions(opts: { [p: string]: any }) {
        this._renderOptions = opts
    }

    getMRUList(): { [id: string]: string }[] {
        return this._dtcMRU
    }

    setMRUList(options: { [id: string]: any }): void {
        const self = this
        let cs = new UIClipboardService()

        self._dtcMRU.unshift(options)
        if (self._dtcMRU.length > 5)
            self._dtcMRU.pop()

        cs.SaveClipboardEntry({
            Usage: "Dimension",
            SubUsage: "Report",
            Clip: options
        })
    }


}
